import { trackEvent } from '../../utils/track/index'

const category = 'PC-login'

function eventFn(label: string, eventid = 12001, value: any = {}, action = 'click') {
  console.log('登录注册埋点', label, eventid, value)
  trackEvent({
    eventid,
    category,
    action,
    label,
    value: {
      ...value,
    },
  })
}

// 登录页面展示
export function signinShowEvent(value = {}) {
  eventFn('loginShow', 12001, value, 'show')
}

// 修改区号埋点
export function changeTelPreEvent(value = {}) {
  eventFn('loginMailtype', 12002, value)
}

// remember7d
export function rememberEvent(value = {}) {
  eventFn('loginRemember7d', 12003, value)
}

// 忘记密码
export function forgotPwEvent(value = {}) {
  eventFn('loginForgetpw', 12004, value)
}

// 登录按钮
export function signinEvent(value = {}) {
  eventFn('loginButton', 12005, value)
}

//  去注册按钮
export function gosignupEvent(value = {}) {
  eventFn('goSignup', 12006, value)
}

// facebook登录
export function facebookEvent(value = {}) {
  eventFn('fbLogin', 12007, value)
}

// google登录
export function googleEvent(value = {}) {
  eventFn('googleLogin', 12008, value)
}

export function kakaoClickEvent() {
  eventFn('loginPage', 12289, { clickContent: 'kakao' })
}

// 登录成功
export function signinSuccessEvent(value = {}) {
  trackEvent({
    eventid: 12009,
    category,
    action: 'show',
    label: 'loginSuccess',
    value,
  })
}

// 注册按钮
export function signupButtonEvent(value = {}) {
  eventFn('loginButton', 12010, value)
}

// 去登录
export function goSigninEvent(value = {}) {
  eventFn('goSignup', 12011, value)
}

// 注册成功
export function signupSuccessEvent(value = {}) {
  eventFn('signupSuccess', 12012, value)
}

// 注册成功
export function wxclickEvent(value = {}) {
  eventFn('wechatLogin', 12663, value)
}
